import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { ArtistsService } from 'src/app/Services/artists.service';
import { AuthService, DeleteUserInfo, ViewUserInfo } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-account-delete',
    templateUrl: './account-delete.component.html',
    styleUrls: ['./account-delete.component.css'],
    providers: [AuthService],
    standalone: false
})
export class AccountDeleteComponent implements OnInit {
    public isAuthenticated: boolean = false;
    public isUsernameValid: boolean = false;
    public isConfirmingDelete: boolean = false;
    public firstName!: string;
    public UserEmail!: string;
    public userId!: string;
    public userLogoUrl!: string;
    public confirmUsername: string = '';
    public userInfo!: ViewUserInfo;
    public confirmPassword: string = '';
    public deleteUserInfo: DeleteUserInfo = new DeleteUserInfo();

    constructor(
        private router: Router,
        private authService: AuthService,
        private notificationsService: NotificationsService,
        private ngxSpinnerService: NgxSpinnerService,
        private confirmationService: ConfirmationService,
        private transloco: TranslocoService
    ) { }

    ngOnInit(): void {
        this.isAuthenticated = this.authService.isAuthenticated();
        if (this.isAuthenticated) {
            const currentUser = this.authService.getCurrentUser();
            if (currentUser) {
                this.firstName = currentUser.FirstName.split(' ')[0];
                this.UserEmail = currentUser.EmailAddress;
                this.userLogoUrl = currentUser.LogoUrl;
                this.userId = currentUser.UserId;
            }
        }
    }

    public deleteAuthenticatedUser(): void {
        if (this.confirmUsername === this.UserEmail && this.confirmPassword) {
            this.confirmationService.confirm({
                message: this.transloco.translate('accountDelete.deleteConfirmMessage'),
                header: this.transloco.translate('accountDelete.confirmationHeader'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.ngxSpinnerService.show();
                    this.deleteUserInfo.Email = this.confirmUsername;
                    this.deleteUserInfo.Password = this.confirmPassword;
                    this.authService.deleteAccount(this.deleteUserInfo).subscribe(
                        (response) => {
                            this.ngxSpinnerService.hide();
                            if (response.Success) {
                                this.notificationsService.showNotification(
                                    this.transloco.translate('accountDelete.successTitle'),
                                    response.ResponseMessage,
                                    NotificationTypes.Success
                                );
                                this.authService.logout().subscribe(() => {
                                    window.location.reload();
                                });
                                this.router.navigate(['/']);
                            } else {
                                this.notificationsService.showNotification(
                                    this.transloco.translate('accountDelete.errorTitle'),
                                    response.ResponseMessage,
                                    NotificationTypes.Error
                                );
                            }
                        },
                        (error) => {
                            console.error('Error deleting account:', error);
                            this.ngxSpinnerService.hide();
                            this.notificationsService.showNotification(
                                this.transloco.translate('accountDelete.errorTitle'),
                                this.transloco.translate('accountDelete.deleteAccountError'),
                                NotificationTypes.Error
                            );
                        }
                    );
                }
            });
        }
        else{
            this.notificationsService.showNotification(
                this.transloco.translate('accountDelete.errorTitle'),
                this.transloco.translate('accountDelete.incorrectCredentials'),
                NotificationTypes.Error
            );
        }
    }

    public verifyUnauthenticatedUsername(): void {
        const userInfo: ViewUserInfo = { Email: this.confirmUsername, Name: '', ImgUrl: '' };
        this.authService.viewUserInfo(userInfo).subscribe(
            (res) => {
                console.log(res);
                this.userInfo = res;
                if (this.userInfo === null) {
                    this.isUsernameValid = false;
                    this.notificationsService.showNotification(this.transloco.translate('accountDelete.errorTitle'), this.transloco.translate('accountDelete.incorrectEmail'), NotificationTypes.Error);
                } else {
                    this.isUsernameValid = true;
                }
            },
        );
    }

    public deleteUnAuthenticated(): void {
        this.confirmationService.confirm({
            message: this.transloco.translate('accountDelete.deleteConfirmMessage'),
            header: this.transloco.translate('accountDelete.confirmationHeader'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.ngxSpinnerService.show();
                this.deleteUserInfo.Email = this.userInfo.Email;
                this.authService.deleteAccount(this.deleteUserInfo).subscribe(
                    (response) => {
                        this.ngxSpinnerService.hide();
                        if (response.Success) {
                            this.notificationsService.showNotification(
                                this.transloco.translate('accountDelete.successTitle'),
                                response.ResponseMessage,
                                NotificationTypes.Success
                            );
                            this.router.navigate(['/']);
                        } else {
                            this.notificationsService.showNotification(
                                this.transloco.translate('accountDelete.errorTitle'),
                                response.ResponseMessage,
                                NotificationTypes.Error
                            );
                        }
                    },
                    (error) => {
                        console.error('Error deleting account:', error);
                        this.ngxSpinnerService.hide();
                        this.notificationsService.showNotification(
                            this.transloco.translate('accountDelete.errorTitle'),
                            this.transloco.translate('accountDelete.deleteAccountError'),
                            NotificationTypes.Error
                        );
                    }
                );
            }
        });
    }

    public cancelDelete(): void {
        this.isConfirmingDelete = false;
        this.router.navigate(['/']);
    }
    public confirmDelete(): void {
        this.isConfirmingDelete = true;
    }

    public Backtoggle() {
        this.isConfirmingDelete = false;
    }
}



